import { Component, OnInit,Input, SimpleChanges } from '@angular/core';

import {Documento} from 'src/app/shared/models/documentos/documentos.interface';
import {DocumentosService} from 'src/app/pages/services/documentos.service';


@Component({
  selector: 'app-lista-prestamo',
  templateUrl: './lista-prestamo.component.html',
  styleUrls: ['./lista-prestamo.component.css']
})
export class ListaPrestamoComponent implements OnInit {
  @Input() fk_trabajador:number=0;

  documentos:Documento[] = [];
  constructor(
    private documentoService: DocumentosService
  ) { }
  ngOnChanges(changes: SimpleChanges) {
    

    if (changes.fk_trabajador.currentValue != changes.fk_trabajador.previousValue){

      this.documentos=[]
      this.documentoService.traerDocsPrestamos(this.fk_trabajador).subscribe(
        (res) => {
          
          this.documentos = res.data;
        }
      );
    }
  
}
  ngOnInit(): void {
    this.documentoService.traerDocsPrestamos(this.fk_trabajador).subscribe(
      (res) => {
        this.documentos = res.data;
       
      }
    );
  }

}
